import { styled } from '@mui/material';

import { TextBlockStyle } from './TextBlock.types';

export const TextContainer = styled('span')(
  ({
    size = 2,
    indent = 0,
    shadow,
    align = 'center',
    color = '#00003f',
    cursor = 'default',
  }: TextBlockStyle) => ({
    fontSize: `${18 * (size / 2)}px`,
    textAlign: align,
    textIndent: `${indent}px`,
    textShadow: `${shadow ? `6px 8px 2px ${shadow}` : ''}`,
    color,
    cursor,

    '@media screen and (min-width: 1920px)': {
      fontSize: `${24 * (size / 2)}px`,
      textIndent: `${indent * 1.5}px`,
      textShadow: `${shadow ? `6px 12px 2px ${shadow}` : ''}`,
    },

    '@media screen and (max-width: 1280px)': {
      fontSize: `${13 * (size / 2)}px`,
      textIndent: `${indent / 1.5}px`,
      textShadow: `${shadow ? `6px 6px 2px ${shadow}` : ''}`,
    },

    '@media screen and (max-width: 640px)': {
      fontSize: `${12 * (size / 2)}px`,
      textIndent: `${indent / 2}px`,
      textShadow: `${shadow ? `4px 6px 2px ${shadow}` : ''}`,
    },
  }),
);
